export function toBoolean (value:any): boolean {
  return value != null && `${value}` !== 'false';
}



// WEBPACK FOOTER //
// ./src/lib/components/common/boolean-property.ts